export const isValueInRange = (
  value: number,
  min?: number,
  max?: number
): boolean => {
  return !((min != null && value < min) || (max != null && value > max));
};
